import axios from './configAxios';

export const deleteContainerApi = async (terminal_id, container_pk) => {
	return axios.delete(`/${terminal_id}/${container_pk}/`);
};
